const EVENT = 'sayable:content-preferences-changed';
const KEY = 'sayable-content-preferences-revision';
let revision = 0;
export const contentPreferenceRevision = () => revision;
export function notifyContentPreferencesChanged() {
  revision += 1;
  window.dispatchEvent(new Event(EVENT));
  try { localStorage.setItem(KEY, `${Date.now()}:${Math.random()}`); } catch (_) { /* The server preference is authoritative. */ }
}
export function subscribeContentPreferences(listener) {
  const onStorage = event => {
    if (event.key === KEY) { revision += 1; listener(); }
  };
  window.addEventListener(EVENT, listener);
  window.addEventListener('storage', onStorage);
  return () => { window.removeEventListener(EVENT, listener); window.removeEventListener('storage', onStorage); };
}
